<template>
    <div class="clock-wrapper d-flex align-items-center justify-content-center" :style="{color:color}">

        <div class="showClock" :style="{color:color,fontSize:`${fs}px`}">
            {{format === "24" ?  fullFormat : halhFormat }}
        </div> 

    </div>
</template>
<script>
export default {
    name:"clockApp",
    props:{
        showSeconds:Boolean,
        format:String,
        color:String,
        width:Number,
        height:Number,
        fs:Number,
        timeZone:String
    },
    data(){
        return{
            fullFormat:"",
            halhFormat:"",
        }
    },
    computed:{
        getActiveObjectProps(){
          return this.$store.getters.getActiveObjectprops
        }
    },
    watch:{
        "$store.state.activeObjectprops" : {
            handler(updatedValues) {
                console.log(this.timeType)
                console.log("checing upd" + updatedValues)
                console.log(updatedValues)
                // this.showSeconds = updatedValues?.showSeconds;
                // this.timeType = updatedValues?.format;
            },
            deep: true,
            immediate: true

        },
    },
    mounted() {
        setInterval(this.updateClock, 1000);
    },
    methods:{
    updateClock() {
        var  currentTime;
        let timezone = this.timeZone;
        if(timezone){
            let dateObject = new Date().toLocaleString("en-US", { timeZone: timezone });
             currentTime =  new Date(dateObject);

        } else {
             currentTime = new Date();
        }
    // Operating System Clock Hours for 12h clock
    var currentHoursAP = currentTime.getHours();
    // Operating System Clock Hours for 24h clock
    var currentHours = currentTime.getHours();
    // Operating System Clock Minutes
    var currentMinutes = currentTime.getMinutes();
    // Operating System Clock Seconds
    var currentSeconds = currentTime.getSeconds();
    // Adding 0 if Minutes & Seconds is More or Less than 10
    currentMinutes = (currentMinutes < 10 ? "0" : "") + currentMinutes;
    currentSeconds = (currentSeconds < 10 ? "0" : "") + currentSeconds;
    // Picking "AM" or "PM" 12h clock if time is more or less than 12
    var timeOfDay = (currentHours < 12) ? "AM" : "PM";
    // transform clock to 12h version if needed
    currentHoursAP = (currentHours > 12) ? currentHours - 12 : currentHours;
    // transform clock to 12h version after mid night
    currentHoursAP = (currentHoursAP == 0) ? 12 : currentHoursAP;
    // display first 24h clock and after line break 12h version

    this.fullFormat =  `${currentHours}:${currentMinutes}${this.showSeconds === true ? `:${currentSeconds}` : ''}`;
    this.halhFormat =  `${currentHoursAP}:${currentMinutes}${this.showSeconds === true ? `:${currentSeconds}` : ''} ${timeOfDay}`;
    
}
   
    }
}    
</script>